var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"84%","margin-left":"7%","margin-top":"20%"}},[_c('p',{staticClass:"SecondTitle"},[_vm._v(" Page not using ")])])])
}]

export { render, staticRenderFns }